import { NgModule } from '@angular/core';
import { CdkAccordion, CdkAccordionModule } from '@angular/cdk/accordion';
import { PmeAccordion } from './accordion.component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    imports: [
        CdkAccordionModule,
        BrowserModule
    ],
    exports: [
        PmeAccordion
    ],
    declarations: [
        PmeAccordion,
    ],
    providers: [CdkAccordion]
})
export class AccordionModule { }
